import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import './Login.css';

function LockScreen() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const user = authService.getCurrentUser();

  async function handleUnlock(e) {
    e.preventDefault();
    
    // Try to login with stored username and provided password
    const result = await authService.login(user?.username || '', password);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔒</div>
          <h2>Screen Locked</h2>
          <p>Enter password to continue</p>
          {user && <p className="user-name">{user.username}</p>}
        </div>

        <form onSubmit={handleUnlock} className="login-form">
          <div className="form-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" className="btn-login">
            Unlock
          </button>
        </form>
      </div>
    </div>
  );
}

export default LockScreen;